// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__t8f94","signatureButtonsRight":"ModalSign_signatureButtonsRight__2965o"};